import { CONTESTS_SHOW_SUCCESS } from '../actions/contests';

const defaultState = [];

export default (state = defaultState, { type, payload = {} }) => {
    switch (type) {
        case CONTESTS_SHOW_SUCCESS: {
            return payload.contests;
        }

        default: {
            return state;
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/reducers/contests.js